import { Button, Dialog } from "@app/ui";
import { useCallback } from "react";
import { useI18n } from "../../lib/useI18n.js";
import { useSettingsStore } from "../../stores/settings.store.js";
import { toast } from "../../stores/toast.store.js";
import { useFeedbackStore } from "./feedback.store.js";
import { FeedbackComposer } from "./FeedbackComposer.js";

export function FeedbackDialog() {
  const { t } = useI18n();
  const open = useFeedbackStore((s) => s.open);
  const image = useFeedbackStore((s) => s.image);
  const source = useFeedbackStore((s) => s.source);
  const note = useFeedbackStore((s) => s.note);
  const close = useFeedbackStore((s) => s.closeFeedback);
  const setMobileScreenshotFeedback = useSettingsStore((s) => s.setMobileScreenshotFeedback);
  const onClose = useCallback(() => close(), [close]);
  const disableScreenshotPrompt = useCallback(async () => {
    await setMobileScreenshotFeedback(false);
    toast.success(t("feedback.disabled"));
    close();
  }, [close, setMobileScreenshotFeedback, t]);
  return (
    <Dialog open={open} onClose={onClose} title={t("about.sendFeedback")}>
      <FeedbackComposer initialNote={note} initialImage={image} source={source} onSent={onClose} />
      {source === "android-screenshot" && (
        <div className="mt-4 border-t pt-3">
          <Button type="button" variant="outline" size="sm" onClick={() => void disableScreenshotPrompt()}>
            {t("feedback.hideAfterScreenshots")}
          </Button>
        </div>
      )}
    </Dialog>
  );
}
